import React from "react";

function SettingsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.828"
      height="26.828"
      version="1.1"
      viewBox="557.786 1174.836 26.828 26.828"
      style={{ WebkitPrintColorAdjust: "exact" }}
    >
      <g className="feather feather-settings">
        <ellipse
          cx="571"
          cy="1188"
          fill="none"
          stroke="#434241"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          rx="3"
          ry="3"
        ></ellipse>
        <path
          fill="none"
          stroke="#434241"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M578.6 1191.25a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51v.17a2 2 0 01-4 0v-.09a1.65 1.65 0 00-1.08-1.51 1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1h-.17a2 2 0 110-4h.09a1.65 1.65 0 001.51-1.08 1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33h.08a1.65 1.65 0 001-1.51v-.17a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82v.08c.259.604.852.997 1.51 1h.17a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1zh0z"
        ></path>
      </g>
    </svg>
  );
}

export default SettingsIcon;
